import { Injectable} from '@angular/core';
import { Http, Headers, Response } from '@angular/http'; 
import { Globals } from '../_Globals/globals'; 

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable() 
export class DebtService {
    public token: string;
 
    

    constructor(private http: Http, private globals: Globals) {
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token; 
    }

    deleteDebt(id: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'debts/delete/' + id + '?tkndel').map(data => {
            data.json(); 
                return data.json();
        });
    }

    uploadDebt(formData, fileCount, inputEl) { 
        /*return this.http.get(this.globals.api_url + 'debts/add')
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                return response;   
            });*/
        
        
            this.http.post(this.globals.api_url + 'debts/add', formData).map((response: Response) => {
                // login successful if there's a jwt token in the response
                return response;  
            });
        
    }

    editBlondalCustomer(data: any[], id) {
        console.log(this.globals.api_url + 'debt_informations/edit/' + id + '?ref=blondal');
        return this.http.post(this.globals.api_url + 'debt_informations/edit/' + id + '?ref=blondal', data)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    editCustomer(data: any[], id) {
        return this.http.post(this.globals.api_url + 'debt_informations/edit/' + id + '?ref=aeon', data)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    assignDebt(id: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'debt_informations/index/' + id)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    insertBlondalToDebt(id: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'debt_informations/insert_blondal_info/' + id)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    insertBlondalHistory(id: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'debt_informations/insert_blondal/' + id)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    addVehicle(id: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'vehicles/insert/' + id)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    getAgencyAssignments(page: Number, getParam: any[]): Observable<any> { 
        var param = 'search=';
        if(getParam != null) {
            param = this._buildParams(getParam);
        } 
        return this.http.get(this.globals.api_url + 'assignments/index/page:' + page + '?' + param)
            .map(data => {
            data.json(); 
                return data.json();
        });
    } 

    getAgencyAssignment(assignment_id: Number, page: Number, getParam: any[]): Observable<any> { 
        var param = 'search=';
        if(getParam != null) {
            param = this._buildParams(getParam);
        } 
        return this.http.get(this.globals.api_url + 'assignments/view/' + assignment_id + '/page:' + page + '?' + param)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }
 

    getReceivables(page: Number, param: any[]): Observable<any> { 
        return this.http.get(this.globals.api_url + 'debts/index/page:' + page + '?' + this._buildParams(param))
            .map(data => {
            data.json();
                // the console.log(...) line prevents your code from working 
                // either remove it or add the line below (return ...)
                //console.log("I CAN SEE DATA HERE: ", data.json());
                return data.json();
        });
    } 

    getDebts(debt_imported_id: Number, page: Number, getparam: any[]): Observable<any> { 
        var param = 'search=';
        if(getparam != null) {
            param = this._buildParams(getparam);
        } 
        console.log(this.globals.api_url + 'debts/getdebt/' + debt_imported_id + '/page:' + page + '?' + param);
        return this.http.get(this.globals.api_url + 'debts/getdebt/' + debt_imported_id + '/page:' + page + '?' + param)
            .map(data => {
            data.json();
                // the console.log(...) line prevents your code from working 
                // either remove it or add the line below (return ...) 
                return data.json();
        });
    }

    getCollections(collection_id: Number, page: Number, getparam: any[]): Observable<any> { 
        var param = 'search=';
        if(getparam != null) {
            param = this._buildParams(getparam);
        }  
        return this.http.get(this.globals.api_url + 'collection_informations/getcollection/' + collection_id + '/page:' + page + '?' + param)
            .map(data => {
            data.json();
                // the console.log(...) line prevents your code from working 
                // either remove it or add the line below (return ...) 
                return data.json();
        });
    }

    getDebt(id: string): Observable<any> {
        
        return this.http.get(this.globals.api_url + 'debts/view/' + id)
            .map(response => {
                // login successful if there's a jwt token in the response
                return response.json(); 
            });
    }

    getDebtAssign(id: string): Observable<any> {
        
        return this.http.get(this.globals.api_url + 'debts/agency_view/' + id)
            .map(response => {
                // login successful if there's a jwt token in the response
                return response.json();  
            });
    }
    

    // Count customer
    countCustomers() {
        return this.http.get(this.globals.api_url + 'debt_informations/count_customer')
            .map(response => {
                // login successful if there's a jwt token in the response
                return response.json();  
            });
    }

    private _buildParams(params: any) {
        let urlSearchParams = new URLSearchParams();

        for(let key in params){
            if(params.hasOwnProperty(key)){
                urlSearchParams.append(key, params[key]);
            }
        }
        return urlSearchParams.toString();
    }

    private _rand(length, current) {
      current = current ? current : '';
      return length ? this._rand(--length, "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".charAt(Math.floor(Math.random() * 60)) + current) : current;
    }
}


// WEBPACK FOOTER //
// ./src/app/_Services/debt.service.ts